<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('meta.sites'), name: 'company_sites' },
            {
              text: site && site.name,
              name: 'site',
              params: {
                uuid: $route.params.uuid,
                site_uuid: $route.params.site_uuid,
              },
            },
            { text: $t('areas.createArea') },
          ]"
        />
      </template>
    </SectionHeader>

    <div class="body-content">
      <CompanyNav />
      <div class="body">
        <LoadingSpinner v-if="loading" />
        <AreaForm v-else :site="site" @submit="createArea" />
      </div>
    </div>
  </div>
</template>

<script>
import AreaForm from '@/views/companies/sites/areas/AreaForm.vue'

import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import areasApi from '@/api/areas'
import sitesApi from '@/api/sites'

export default {
  name: 'new_area',
  data: () => ({
    loading: true,
    site: null,
  }),
  components: {
    AreaForm,
    BreadCrumbs,
    CompanyNav,
    LoadingSpinner,
    SectionHeader,
  },
  methods: {
    async createArea(area) {
      const newArea = await areasApi.create(this.$route.params.site_uuid, area)
      if (newArea) {
        await this.$router.push(`/company/sites/${this.$route.params.site_uuid}`)
      }
    },
  },
  async mounted() {
    this.site = await sitesApi.get(this.$route.params.site_uuid)
    this.loading = false
  },
}
</script>
